<div class="table-container">
  <div class="virtual-scroll-viewport" [style.height.px]="viewportHeight">
    <table>
      <thead>
        <tr>
          <th></th> <!-- Arrow column -->
          <th
            *ngFor="let col of config?.columns"
            [class.sortable]="col.sortable"
            (click)="col.sortable && sortColumn(col.key)"
          >
            <div class="header-content">
              {{ col.title }}
              <img
                *ngIf="sortKey === col.key"
                [src]="
                sortDirection === 'asc'
                ? 'assets/icons/column-sort-indicator-ascending.svg'
                : 'assets/icons/column-sort-indicator-descending.svg'
                "
                [alt]="sortDirection === 'asc' ? 'Ascending' : 'Descending'"
              />
              <img
                *ngIf="sortKey !== col.key && col.sortable"
                src="assets/icons/column-sort-indicator.svg"
                alt="Sortable"
              />
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- Loading State -->
        <tr *ngIf="isLoading">
          <td [attr.colspan]="config?.columns.length + 1" class="loading-cell">
            <app-pol-loader
              skeletonSize="large"
              [skeletonRows]="20"
              skeletonAlignment="table-aligned"
              skeletonType="text"
            ></app-pol-loader>
          </td>
        </tr>

        <!-- Data Rows -->
        <ng-container *ngIf="!isLoading && data && data.length; else noDataTemplate">
          <ng-container *ngFor="let row of data; let i = index">
            <tr (click)="toggleRow(i)" [class.expanded-row]="expandedRow === i">
              <td class="arrow-cell">
                <span class="arrow" [class.expanded]="expandedRow === i"></span>
              </td>
              <td *ngFor="let col of config?.columns" [class.centered]="col.type === 'icon'">
                @if(col.type === undefined || col.type === 'text') {
                  {{ row[col.key] }}
                }

                @if(col.type === 'icon') {
                  @if(col.icon(row).isOrchid) {
                    <ods-icon [variant]="col.icon(row).icon" [style]="{ color: col.icon(row).color }" />
                  } @else {
                    <img class="td-icon" [style]="makeIconStyle(col, row)" />
                  }

                  @if(col.icon(row).iconSuffix) {
                    <span class="td-icon-suffix">{{ col.icon(row).iconSuffix }}</span>
                  }
                }
              </td>
            </tr>
            <tr *ngIf="expandedRow === i" class="expanded-row">
              <td [attr.colspan]="config?.columns.length + 1">
                <div class="expanded-content">
                  <ng-container
                    *ngTemplateOutlet="expandedTemplate; context: { $implicit: row }"
                  >
                  </ng-container>
                </div>
              </td>
            </tr>
          </ng-container>
        </ng-container>

        <!-- No Data Template -->
        <ng-template #noDataTemplate>
          <tr *ngIf="!isLoading && (!data || !data.length)">
            <td [attr.colspan]="config?.columns.length + 1" class="no-data-message">
              {{ tableMessage }}
            </td>
          </tr>
        </ng-template>
      </tbody>
    </table>
  </div>
</div>

